import { Link } from '@inertiajs/react'
import React from 'react'
import AccountSwitcher from '../../../Components/AccountSwitcher'

const NAV_LINKS = [
  { view: 'board', label: 'Live Board', href: '/kitchen' },
  { view: 'today', label: "Today's Orders", href: '/kitchen/today' }
]

export function KitchenHeader({ account, accounts, view = 'board', audioEnabled, onToggleAudio, onLock }) {
  const current = NAV_LINKS.find(l => l.view === view)

  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Kitchen Display</h1>
            <AccountSwitcher account={account} accounts={accounts} baseUrl={current?.href || '/kitchen'} />
          </div>
          <nav className="flex rounded-lg bg-gray-100 p-1">
            {NAV_LINKS.map(link => (
              <Link
                key={link.view}
                href={link.href}
                className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
                  view === link.view
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-4">
            {onToggleAudio && (
              <button
                onClick={onToggleAudio}
                className={`px-4 py-2 rounded-lg font-medium ${
                  audioEnabled
                    ? 'bg-green-100 text-green-700'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                {audioEnabled ? '🔔 Sound On' : '🔕 Sound Off'}
              </button>
            )}
            {onLock && (
              <button
                onClick={onLock}
                className="px-4 py-2 rounded-lg font-medium bg-gray-100 text-gray-700 hover:bg-gray-200"
              >
                🔒 Lock
              </button>
            )}
            <div className="text-sm text-gray-600">
              {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
